import { render, staticRenderFns } from "./OverseaServiceList.vue?vue&type=template&id=0d41ab45&scoped=true"
import script from "./OverseaServiceList.vue?vue&type=script&lang=js"
export * from "./OverseaServiceList.vue?vue&type=script&lang=js"
import style0 from "./OverseaServiceList.vue?vue&type=style&index=0&id=0d41ab45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d41ab45",
  null
  
)

export default component.exports